import type { Task } from '../model/types/tasks';
import type { Board } from '../model/types/tasksInformationSchema';

type TaskDates = Pick<Task, 'date_start' | 'date_end'>;

const getSortDate = (task: TaskDates | undefined): number | null => {
    const date = task?.date_start || task?.date_end;
    return date ? Number(date.split('.').reverse().join('')) : null;
};

export const sortBoardTaskIds = (
    column: keyof Board,
    taskIds: string[],
    tasks: Record<string, TaskDates | undefined>
): string[] => {
    if (column !== 'outdated' && column !== 'in_progress' && column !== 'seven_days') {
        return taskIds;
    }

    const direction = column === 'outdated' ? -1 : 1;

    return [...taskIds].sort((idA, idB) => {
        const dateA = getSortDate(tasks[idA]);
        const dateB = getSortDate(tasks[idB]);

        if (dateA === null || dateB === null) {
            return Number(dateA === null) - Number(dateB === null);
        }

        return direction * (dateA - dateB);
    });
};
